/**
 * Render out the friendly label for the given `availability` integer
 * from user.availability.
 *
 * @export
 * @param {any} availability The availability integer to render. Found on user.availability.
 * @returns {String|Error} The friendly string for the given status.
 */
const availabilityLabels = {
  0: 'Offline',
  1: 'Available',
  2: 'Away',
  3: 'Busy'
};

export default function(availability) {
  return availabilityLabels[availability] || 'Unknown status';
}



// WEBPACK FOOTER //
// ./src/utils/availability-label.js